export async function getNovelCollectionArtifactAbi(isTestnet: boolean) {
    return (
        await (isTestnet
            ? import("@novel/shared/__generated__/NovelCollectionContractTestnet.json")
            : import("@novel/shared/__generated__/NovelCollectionContract.json"))
    ).abi;
}
